
export const accounts = {
  'accounts.title': 'Yatırım Hesapları',
  'accounts.subtitle': 'Yatırım hesaplarınızı görüntüleyin ve yönetin',
  'accounts.loading': 'Hesaplar yükleniyor...',
  'accounts.error': 'Hesaplar yüklenirken hata',
  'accounts.noAccounts': 'Yatırım hesabı bulunamadı',
  'accounts.accountNumber': 'Hesap Numarası',
  'accounts.balance': 'Bakiye',
  'accounts.accountShare': 'Hesap Payı',
  'accounts.accountOpen': 'Hesap Açılış',
  'accounts.broker': 'Broker',
  'accounts.active': 'Aktif',
  'accounts.inactive': 'Pasif',
  'accounts.pending': 'Beklemede',
  'accounts.closed': 'Kapalı',
  
  // Transactions section
  'accounts.transactions.title': 'Hesap İşlemleri',
  'accounts.transactions.subtitle': 'Para yatırma ve çekme geçmişinizi görüntüleyin',
  'accounts.transactions.loading': 'İşlemler yükleniyor...',
  'accounts.transactions.error': 'İşlemler yüklenirken hata',
  'accounts.transactions.noTransactions': 'İşlem bulunamadı',
  'accounts.transactions.export': 'CSV Dışa Aktar',
  'accounts.transactions.loadMore': 'Daha Fazla Yükle',
  
  // Table columns
  'accounts.transactions.table.account': 'Hesap',
  'accounts.transactions.table.date': 'Tarih',
  'accounts.transactions.table.amount': 'Tutar',
  'accounts.transactions.table.operation': 'İşlem',
  
  // Operations
  'accounts.transactions.deposit': 'Para Yatırma',
  'accounts.transactions.withdrawal': 'Para Çekme',
  
  // Filters
  'accounts.transactions.filters.account': 'Hesaba Göre Filtrele',
  'accounts.transactions.filters.operation': 'İşleme Göre Filtrele',
  'accounts.transactions.filters.dateFrom': 'Başlangıç Tarihi',
  'accounts.transactions.filters.dateTo': 'Bitiş Tarihi',
  'accounts.transactions.filters.apply': 'Filtreleri Uygula',
  'accounts.transactions.filters.reset': 'Filtreleri Sıfırla',
  'accounts.transactions.filters.allAccounts': 'Tüm Hesaplar',
  'accounts.transactions.filters.allOperations': 'Tüm İşlemler',
  
  // Add Account section
  'accounts.addAccount.title': 'PAMM Yatırım Hesabı Ekle',
  'accounts.addAccount.subtitle': 'PAMM Hesap Kimliği ve İlişkili E-posta Sağlayın',
  'accounts.addAccount.pammAccount': 'PAMM Hesabı',
  'accounts.addAccount.associatedEmail': 'İlişkili E-posta',
  'accounts.addAccount.validateAccount': 'Hesabı Doğrula',
  'accounts.addAccount.instructionsTitle': 'PAMM Hesabınızı bulmak için aşağıdaki talimatları izleyin',
  'accounts.addAccount.step1.title': 'E-postanızda aldığınız kimlik bilgileriyle PAMM hesabınıza giriş yapın',
  'accounts.addAccount.step1.substep1': 'Konusu: "RADEX MARKETS - Successfully joined PAMM of the money manager - The Club Funding Pro" olan bir e-posta arayın',
  'accounts.addAccount.step1.substep2': 'E-postada sağlanan bağlantıyı açın: https://pamm.radexmarkets.com/app/auth/investor',
  'accounts.addAccount.step2.title': 'Az önce giriş yaptığınız Radex Markets Portalından PAMM Hesap Kimliğinizi alın',
  'accounts.addAccount.step2.description': 'PAMM Hesap Kimliği aşağıdaki resimde vurgulanmıştır',
  'accounts.addAccount.validation.pammAccountRequired': 'PAMM Hesabı zorunludur',
  'accounts.addAccount.validation.pammAccountInvalid': 'PAMM Hesabı pozitif bir sayı olmalıdır',
  'accounts.addAccount.validation.emailRequired': 'İlişkili E-posta zorunludur',
  'accounts.addAccount.validation.emailInvalid': 'Lütfen geçerli bir e-posta adresi girin',
  'accounts.addAccount.success': 'Hesap başarıyla doğrulandı',
  'accounts.addAccount.error': 'Hesap doğrulanırken hata',
  'accounts.addAccount.validating': 'Hesap doğrulanıyor...',
  'accounts.addAccount.successDescription': 'Yatırım hesabınız başarıyla eklendi.',
  
  // Error messages
  'accounts.addAccount.messages.success': 'Hesap başarıyla doğrulandı ve eklendi',
  'accounts.addAccount.messages.missing_fields': 'Lütfen tüm zorunlu alanları doldurun',
  'accounts.addAccount.messages.account_exists': 'Bu yatırım hesabı zaten kayıtlı',
  'accounts.addAccount.messages.account_already_registered': 'Bu hesap kaydedilemez',
  'accounts.addAccount.messages.account_not_active': 'Hesap aktif değil. Doğrulamadan önce hesabınızın aktif olduğundan emin olun',
  'accounts.addAccount.messages.account_validation_failed': 'Hesap doğrulama başarısız oldu. Hesap numaranızı ve e-posta adresinizi doğrulayın',
  'accounts.addAccount.messages.insert_failed': 'Hesap kaydedilemedi. Lütfen tekrar deneyin',
  'accounts.addAccount.messages.server_error': 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin',
  'accounts.addAccount.messages.systemError': 'İşlem başarısız oldu, daha sonra deneyin veya Müşteri Desteği ile iletişime geçin',
  
  // Placeholders
  'accounts.addAccount.placeholders.pammAccount': 'PAMM Hesap Kimliğini girin',
  'accounts.addAccount.placeholders.associatedEmail': 'İlişkili E-postayı girin',
  
  // General
  'accounts.notAvailable': 'Mevcut değil',
  'accounts.addNewAccount': 'Yeni Hesap Ekle',
};
